// src/features/tasks/components/TaskAttachmentModal/index.jsx
import React from 'react';
import styles from './TaskAttachmentModal.module.css';

function TaskAttachmentModal({ imageUrl, onClose, taskTitle }) {
  if (!imageUrl) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>&times;</button>
        <img
          src={imageUrl}
          alt={`مرفق المهمة: ${taskTitle}`}
          className={styles.modalImage}
        />
      </div>
    </div>
  );
}

export default TaskAttachmentModal;